import { useApplicationContext } from 'shared/utils/applicationContext';
import { getContentForFirstBlock, getPageContent } from './utils';
import { FirstBlock } from 'shared/components/FirstBlock';
import { Footer } from 'shared/components/Footer';
import { TelegramBanner } from 'shared/components/TelegramBanner';
import { Content } from 'shared/components/Content';

export const PagesContainer: React.FC = () => {
  const {
    custom: { pageType },
  } = useApplicationContext();

  const firstBlockContent = getContentForFirstBlock(pageType);

  const PageContent = getPageContent(pageType);

  return (
    <>
      <FirstBlock {...firstBlockContent} />
      <Content child={<PageContent />} />
      <TelegramBanner />
      <Footer />
    </>
  );
};
